import { Button } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel, Grid, SvgIcon, Menu } from "@material-ui/core";

import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { IconFlagCA, IconFlagIN, IconFlagUS } from "material-ui-flags";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import { getDate, getDateTime, searchFilter, handleSort } from "../utils/varialbles";
import SearchBar from "material-ui-search-bar";
//import Filter from '../components/filerComponent';
// comment the above one replace with below 1 --step1
import useFilter from "../components/filterComponent";
import toast from "react-hot-toast";
import { ReactComponent as FilterLogo } from "../images/filter.svg";
import filterData from "../components/filterCriteria";
const getFlags = (country) => {
  let CountryMapper = {
    India: IconFlagIN,
    USA: IconFlagUS,
    Canada: IconFlagCA,
  };
  if (country && CountryMapper[country]) {
    return React.createElement(CountryMapper[country]);
  } else {
    return React.createElement(CountryMapper["India"]);
  }
};

const getCurrency = (name) => {
  let currencyMapper = {
    INR: "₹",
    USD: "$",
    CAD: "C$",
  };
  if (name && currencyMapper[name]) {
    return currencyMapper[name];
  } else {
    return currencyMapper["INR"];
  }
};
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 5,
    marginBottom: 10
  },
  button: {
    borderRadus: 10,
  },
  detailsButton: {
    backgroundColor: "#fff",
    color: "#3c52b2",
    "&:hover": {
      backgroundColor: "#3c52b2",
      color: "#fff",
    },
    borderColor: "#3c52b2",
  },
}));
const columns = [
  { id: "Date", label: "Date", minWidth: 170, format: 'Date' },
  { id: "Name", label: "Name", minWidth: 170 },
  { id: "Type", label: "Type", minWidth: 150 },
  { id: "Subject", label: "Subject", minWidth: 150 },
  {
    id: "Frequency",
    label: "Frequency",
    minWidth: 150,
    filter: true,
    filterType: "dropDown",
    conditions: [{ text: "Equal", value: "eq" }],
    options: "data",
    multi: false,
  },
  { id: "Conditions", label: "Conditions", minWidth: 150 },
  { id: "detailsButton", label: "Edit", minWidth: 150 },

];

// const columns = [
//   { title: "Name", field: "First_Name" },
//   { title: "Type", field: "Last_Name" },
//   { title: "Subject", field: "mobile" },
//   // { title: "Colour", field: "color" },
//   { title: "Frequency", field: "sub_date" },
//   { title: "Subscription Status", field: "sub_status" },
//   { title: "Conditions", field: "eye"},
//   // { title: "Edit", field: "edit" }
// ];

function NotificationManagerOverview() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const location = useLocation();
  const myparam = location.state;
  const form = {
    Frequency: "",
  };
  const [formObject, setFormObject] = React.useState(form);
  const clearFilter = () => {
    setFormObject(form);
    setRows(orignalRows);
  };
  const applyFilter = (e) => {
    let tempObject = { ...formObject };
    let tempORows = [...orignalRows];
    let filter = filterData(tempObject, tempORows, columns);
    setRows(filter);
    setPage(0);
  };
  const openFilter = (e) => {
    let currentTarget = e.currentTarget;
    setAnchorEl(currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (e) => {
    setFormObject({
      ...formObject,
      [e.target.name]: e.target.value,
    });
  };
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  let history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const editNotification = (record) => { };


  // added the below line --step2
  const [Filter, filterString, passFilters, passData] = useFilter();

  const [totalRowCount, setTotalRowCount] = React.useState(0);
  const getPaginationURL = (url, newQuery) => {
    const query = newQuery ? newQuery : searched;
    if (query) {
      return `${url}?page=${page + 1
        }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };
  const getData = (newQuery) => {
    const baseURL = "/list_notification";
    toast.loading("Please wait...");

    setOriginalRows([]);
    setRows([]);
    http
      .get(getPaginationURL(baseURL, newQuery) + filterString)
      .then((response) => {
        // added filterString concat step3
        // ("rowoow");
        // (response);
        // http.get("/investment_manager").then((response) => {
        toast.dismiss();

        if (
          response &&
          response.data &&
          response.data.Data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          // ("ooooooo");
          setOriginalRows(response.data.Data);
          setRows(response.data.Data);
          setTotalRowCount(response.data.totalRowCount);
          if (!filterString) passFilters(response.data.filter || []); // added if condition step4
        }
      });
  };
  useEffect(() => {
    getData();
    if (myparam && myparam.page) {
      setPage(myparam.page);
      delete myparam.page;
    }
  }, [page, rowsPerPage, filterString]); //added filterString into this array step5

  return (
    <div className={classes.root}>
      <Paper className={classes.root}>
        <SearchBar
          value={searched}
          onChange={(searchVal) => requestSearch(searchVal)}
          onCancelSearch={() => cancelSearch()}
          className={"mt30"}
        />
        <Grid container>
          <Grid item xs={10} sm={11} style={{ paddingTop: 10 }}>
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 1500]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
          <Grid item xs={2} sm={1}>
            <SvgIcon
              style={{ cursor: "pointer", marginTop: 20 }}
              onClick={openFilter}
              title={"filter"}
            >
              <FilterLogo />
            </SvgIcon>
            <Menu
              anchorEl={anchorEl}
              id={"Filtermenu"}
              keepMounted
              open={isMenuOpen}
              onClose={handleMenuClose}
              getContentAnchorEl={null}
              transformOrigin={{ horizontal: "rigth", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              {/* <Filter columns={columns} applyFilter={applyFilter} orignalRows={orignalRows}
                       handleChange={handleChange} formObject={formObject} clearFilter={clearFilter}/>
                       
                        {/* comment the above one replace with below 1 --step6 */}
              <Filter data={passData} />
            </Menu>
          </Grid>
        </Grid>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                rows.length !== 0 ? (
                  <>
                    {rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index + "a"}
                          >
                            {columns.map((column, index) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={index + column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number" ? (
                                    column.format(value)
                                  ) : column.format === "Date" ? (
                                    getDateTime(value)
                                  ) : column.operation &&
                                    column.operation === "concate" ? (
                                    value + column.operand + row[column.with]
                                  ) : column.format === "boolean" &&
                                    row[column.id] ? (
                                    "Yes"
                                  ) : column.format === "boolean" &&
                                    !row[column.id] ? (
                                    "No"
                                  ) : column.id === "detailsButton" ? (
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      style={{ borderRadius: 20 }}
                                      onClick={() => editNotification(row)}
                                    >
                                      {column.label}
                                    </Button>
                                  ) : value ? (
                                    value
                                  ) : (
                                    "N/A"
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </>
                ) : (
                  <TableCell
                    colspan="9"
                    style={{ "text-align": "center", margin: "10px 0px" }}
                  >
                    Records Not Available
                  </TableCell>
                )
              }

            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
export default NotificationManagerOverview;
